import React from "react";
import PropTypes from "prop-types";
import { Typography, Avatar } from "@material-ui/core";
import BarChartIcon from "@material-ui/icons/BarChart";

/**
 * Summary page header component
 */
export const SummaryHeader = ({ classes }) => {
  return (
    <div className={classes.paper}>
      <Avatar className={classes.avatar}>
        <BarChartIcon />
      </Avatar>
      <Typography
        component="h1"
        variant="h4"
        style={{ marginBottom: "10px" }}
      >
        SUMMARY
      </Typography>
    </div>
  );
};

SummaryHeader.propTypes = {
  classes: PropTypes.object.isRequired,
};

